import { cloneDeep } from 'lodash';
import {
  CONFIG_STATUS_LEVEL,
  CONFIG_TYPES,
  CRITERIA,
  CRM_PARENT_LINK_STATUS_TEMPLATE,
  DATA_MAPPING_TYPES,
  SIDE_NAV_BAR_OPTIONS,
} from '../../../../common/constants/integrationConstants/crmConstants';
import { getParentLinkObj } from '../../../../common/util/crmIntegrationUtils/crmUtils';
import {
  cancelParentLinkStatus,
  changeParentLinkStatus,
  clearUnsavedChanges,
  fetchParentLinkConfigStatus,
  saveParentLinkConfigStatus,
} from '../../../routines/integrations/crmRoutines';

const initialState = {
  [CONFIG_TYPES.PARENT_LINK]: {
    create: CRM_PARENT_LINK_STATUS_TEMPLATE,
    update: CRM_PARENT_LINK_STATUS_TEMPLATE,
    na: CRM_PARENT_LINK_STATUS_TEMPLATE,
  },
  linkParentType: DATA_MAPPING_TYPES.DEAL_PRIMARY_COMPANY,
  persistedStateParentLink: null,
  loading: false,
  error: null,
  hasUnSavedConfig: false,
};

const crmParentLinkReducer = (state = initialState, action) => {
  switch (action.type) {
    case clearUnsavedChanges.TRIGGER: {
      const { sideNavBarTab } = action.payload;
      const { hasUnSavedConfig } = { ...state };
      if (
        (sideNavBarTab === CRITERIA.CREATE ||
          sideNavBarTab === CRITERIA.UPDATE ||
          sideNavBarTab === SIDE_NAV_BAR_OPTIONS.IN_SYNC) &&
        hasUnSavedConfig
      ) {
        const previousParentLinkStatus = cloneDeep(
          state.persistedStateParentLink
        );
        return {
          ...state,
          [CONFIG_TYPES.PARENT_LINK]: previousParentLinkStatus,
          hasUnSavedConfig: false,
        };
      }
      return {
        ...state,
      };
    }
    case saveParentLinkConfigStatus.TRIGGER:
      return {
        ...state,
      };
    case saveParentLinkConfigStatus.SUCCESS: {
      const { criteria, enable } = action.payload;
      const newParentLinkState = {
        ...state[CONFIG_TYPES.PARENT_LINK],
        [criteria]: {
          ...state[CONFIG_TYPES.PARENT_LINK][criteria],
          enable,
          status: CONFIG_STATUS_LEVEL.SAVED,
        },
      };
      return {
        ...state,
        [CONFIG_TYPES.PARENT_LINK]: newParentLinkState,
        persistedStateParentLink: newParentLinkState,
        loading: false,
        error: false,
        hasUnSavedConfig: false,
      };
    }
    case changeParentLinkStatus.TRIGGER: {
      const { criteria, enable, sideNavBarTab } = action.payload;
      const criteriaToChange =
        sideNavBarTab === SIDE_NAV_BAR_OPTIONS.IN_SYNC ? 'na' : criteria;
      return {
        ...state,
        [CONFIG_TYPES.PARENT_LINK]: {
          ...state[CONFIG_TYPES.PARENT_LINK],
          [criteriaToChange]: {
            ...state[CONFIG_TYPES.PARENT_LINK][criteriaToChange],
            enable,
            status: CONFIG_STATUS_LEVEL.COMPLETED,
          },
        },
        hasUnSavedConfig: true,
      };
    }
    case cancelParentLinkStatus.TRIGGER: {
      const previousLinkParentStatus = cloneDeep(
        state.persistedStateParentLink
      );
      return {
        ...state,
        [CONFIG_TYPES.PARENT_LINK]: previousLinkParentStatus,
        hasUnSavedConfig: false,
      };
    }
    case fetchParentLinkConfigStatus.TRIGGER:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case fetchParentLinkConfigStatus.SUCCESS: {
      const data = action.payload || {};
      const parentLinkConfigItems = Object.values(data);

      const createParentLinkObj = parentLinkConfigItems.find(
        (item) => item.criteria === CRITERIA.CREATE
      );
      const updateParentLinkObj = parentLinkConfigItems.find(
        (item) => item.criteria === CRITERIA.UPDATE
      );

      const inSyncParentLinkObj = parentLinkConfigItems.find(
        (item) => item.criteria === 'na'
      );

      const newLinkParentState = {
        create: createParentLinkObj
          ? getParentLinkObj(createParentLinkObj)
          : state[CONFIG_TYPES.PARENT_LINK][CRITERIA.CREATE],
        update: updateParentLinkObj
          ? getParentLinkObj(updateParentLinkObj)
          : state[CONFIG_TYPES.PARENT_LINK][CRITERIA.UPDATE],
        na: inSyncParentLinkObj
          ? getParentLinkObj(inSyncParentLinkObj)
          : state[CONFIG_TYPES.PARENT_LINK].na,
      };
      return {
        ...state,
        [CONFIG_TYPES.PARENT_LINK]: newLinkParentState,
        persistedStateParentLink: newLinkParentState,
        loading: false,
        error: false,
        hasUnSavedConfig: false,
      };
    }
    default:
      return state;
  }
};
export default crmParentLinkReducer;
